import { render } from "./AppSerialLabelPrint.vue?vue&type=template&id=04c2b12d"
import script from "./AppSerialLabelPrint.vue?vue&type=script&lang=js"
export * from "./AppSerialLabelPrint.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__